const requestServiceMixin = {
    data: function () {
        return {
            serverErrorMessage: '',
            isLoading: false,
        };
    },
    methods: {
        getLastPart(endpoint) {
            const trimmed = endpoint.endsWith('/') ? endpoint.slice(0, -1) : endpoint;
            const parts = trimmed.split('/');
            return parts[parts.length - 1];
        },
        async getRecaptchToken(endpoint) {
            let recaptcha_token = '';

            let data = {
                action: this.getLastPart(endpoint),
            };

            grecaptcha.ready(() => {
                grecaptcha.execute(GLOBAL.RECAPTCHASITEKEY, data).then((token) => {
                    recaptcha_token = token;
                });
            });

            while (recaptcha_token == '') {
                await new Promise((r) => setTimeout(r, 100));
            }

            return recaptcha_token;
        },
        async post(baseUrl, endpoint, data, recaptcha = false) {
            const vm = this;
            vm.isLoading = true;

            let reCaptchaToken = '';

            if (recaptcha) {
                reCaptchaToken = await vm.getRecaptchToken(endpoint);
            }

            return await axios({
                method: 'post',
                url: baseUrl + endpoint,
                headers: {
                    __requestverificationtoken: GLOBAL.ANTIFORGERYTOKEN,
                    __recaptchatoken: reCaptchaToken,
                },
                data: data,
            })
                .then(function (response) {
                    if (!response) {
                        vm.serverErrorMessage = "No response";
                        serverError.scrollIntoView();
                        vm.isLoading = false;
                        return null;
                    }
                    const content = response.data.content;
                    vm.isLoading = false;
                    if (content.errors !== null) {
                        const serverError = vm.$refs['server-error'];

                        if (serverError) {
                            const errorObj = JSON.parse(content.errors);
                            vm.serverErrorMessage = errorObj.message;
                            serverError.scrollIntoView();
                            return null;
                        }
                    }

                    vm.serverErrorMessage = '';
                    return response;
                })
                .catch(function (error) {
                    if (error.response && error.response.status === 400) {
                    }
                    else
                    {
                        rg4js('send', {
                            error: error,
                            customData: {
                                baseUrl: baseUrl,
                                endpoint: endpoint,
                                data: data,
                                recaptcha: recaptcha,
                                productPrice: productPrice,
                            },
                        });
                    }

                    vm.isLoading = false;
                    const serverError = vm.$refs['server-error'];

                    if (serverError) {
                        vm.serverErrorMessage = 'Sorry there has been an error. Please contact us, or try again shortly.';
                    }
                });
        },
        get: function (baseUrl, endpoint, data) {
            const vm = this;
            vm.isLoading = true;

            return axios({
                method: 'get',
                url: baseUrl + endpoint,
                params: data,
            })
                .then(function (response) {
                    vm.isLoading = false;
                    return response;
                })
                .catch(function (error) {
                    if (typeof rg4js !== "undefined") {
                        rg4js('send', {
                            error: error,
                            customData: {
                                baseUrl: baseUrl,
                                endpoint: endpoint,
                                data: data,
                            },
                        });
                    }
                    vm.isLoading = false;
                });
        },
    },
};
